import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from '@app/core/services/api/api.service';
import { IntegrationsService } from '@app/services/integrations/integrations.service';
import { ToastService } from '@app/storybook/services/toast/toast.service';
import { Integration, IntegrationType } from '@pdqdev/pdq-shared/dist/entities';
import { TimeUnits } from '@utils/times-utils';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
enum PlatformSettingsOption {
  PROVIDE_TAGS = 'provideTags',
}

@Component({
  selector: 'integration-platform-specific-components',
  templateUrl: './integration-platform-specific-components.component.html',
  styleUrls: ['./integration-platform-specific-components.component.scss'],
  standalone: false,
})
export class IntegrationPlatformSpecificComponentsComponent implements OnInit {
  @Input() integrationType: IntegrationType;
  @Input() integration: Integration;

  constructor(
    private apiService: ApiService,
    private integrationService: IntegrationsService,
    private toastService: ToastService,
  ) {}
  PlatformSettingsOption = PlatformSettingsOption;

  destroy$ = new Subject();
  featureToggle$ = new Subject<{ feature: PlatformSettingsOption; value: boolean }>();
  handleToggle(value: boolean, feature: PlatformSettingsOption) {
    this.featureToggle$.next({ feature, value });
  }

  toggleMetadataFeature(newIsActive: boolean, option: PlatformSettingsOption) {
    this.apiService.post(`integrations/metadata/${this.integration.id}`, { key: option, value: newIsActive }).subscribe(
      (updatedIntegration) => {
        this.integrationService.updateIntegrationState(updatedIntegration);
      },
      (err) => {
        console.log(err);
        this.toastService.showToast({
          mode: 'danger',
          message: `Failed to toggle ${newIsActive ? 'on' : 'off'} a settings option`,
        });
      },
    );
  }

  ngOnInit(): void {
    this.featureToggle$
      .pipe(takeUntil(this.destroy$), debounceTime(TimeUnits._SECOND_IN_MS * 1), distinctUntilChanged())
      .subscribe(({ feature, value }) => this.toggleMetadataFeature(value, feature as PlatformSettingsOption));
  }
}
